import { owners as defaultOwners } from "@/data/content";
import { Quote } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { usePhotos } from "@/hooks/usePhotos";

export default function Owners() {
  const { content } = useContent();
  const { photos, loaded } = usePhotos();

  const hostPhotos = photos.filter((p) => p.category === "hosts");
  const uploaded = hostPhotos.length > 0 ? hostPhotos[hostPhotos.length - 1].data_url : null;
  const portrait = uploaded || (loaded ? defaultOwners.portrait : null);

  return (
    <section
      id="owners"
      data-testid="owners-section"
      className="py-20 md:py-28 bg-[#232E26] text-[#FAF7F2] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5 order-2 md:order-1">
          <div className="relative">
            <div className="w-full aspect-[4/5] bg-[#3a4a3f]" />
            {portrait && (
              <img
                src={portrait}
                alt="Hosts of Mirabella Anemoessa"
                data-testid="owners-portrait"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            )}
            <div className="absolute -bottom-4 -right-4 hidden md:block bg-[#C65D47] h-24 w-24" />
          </div>
        </div>

        <div className="md:col-span-7 order-1 md:order-2">
          <p className="overline text-[#EAE0D5]/70">{content.ownersTitle}</p>
          <Quote className="mt-4 text-[#C65D47]" size={36} />
          <h2
            data-testid="owners-title"
            className="font-serif-display text-3xl md:text-4xl mt-4 leading-[1.2]"
          >
            We are travelers who fell in love with Greece &mdash; and we&apos;re delighted
            to host you.
          </h2>
          <p
            data-testid="owners-body"
            className="mt-6 text-[#EAE0D5]/85 leading-relaxed whitespace-pre-line text-[15px]"
          >
            {content.ownersBody}
          </p>
        </div>
      </div>
    </section>
  );
}
